import { createTheme } from '@mui/material/styles';

/**
 * MUI-Theme mit den CORAmaps-Markenfarben (§6 des Plans).
 * Übernommen aus insurance_UI: Primär-Blau #0048a0, Sekundär-Orange #dd8450,
 * Schrift Open Sans.
 */
const theme = createTheme({
  palette: {
    primary: { main: '#0048a0' },
    secondary: { main: '#dd8450' },
    text: {
      primary: '#143f6c',
      secondary: '#496179',
    },
    background: {
      default: '#f6faff',
    },
  },
  typography: {
    fontFamily: "'Open Sans', 'Segoe UI', sans-serif",
    h1: { fontWeight: 700, color: '#143f6c' },
    h2: { fontWeight: 700, color: '#143f6c' },
    h3: { fontWeight: 700, color: '#143f6c' },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  shape: {
    borderRadius: 12,
  },
});

export default theme;
